import React, { FC } from "react";
import { Table, Group, Text, Image, Box } from "@mantine/core";
import { TeamLogo } from "../../../Components/TeamLogo.tsx";
import { TeamName } from "../../../Components/TeamName.tsx";
import { getPresentationParamsForOrigin } from "../../../getPresentationParamsForOrigin.ts";
import { useLeaderboard } from "../../../hooks/useLeaderboard.ts";
import { useRequiredParams } from "../../../hooks/useRequiredParams.ts";
import { useCompetition } from "../../../hooks/useCompetition.ts";

const tdStyle: React.CSSProperties = {
  paddingTop: 15,
  paddingBottom: 15,
  paddingLeft: 30,
  paddingRight: 30,
  color: "white",
};

export const LeaderboardFullscreen: FC = () => {
  const { competitionId, groupId } = useRequiredParams([
    "competitionId",
    "groupId",
  ]);

  const competition = useCompetition(competitionId);
  const group = competition.data?.groups.find((g) => g.id === groupId);

  const leaderboardData = useLeaderboard(competitionId, groupId);

  if (!leaderboardData.isSuccess) {
    return <></>;
  }

  const teams = leaderboardData.data.leaderboard.slice(0, 5);

  const textApp =
    leaderboardData.data.leaderboard.length > teams.length ? (
      <>
        <strong>Ganze Tabelle:</strong>{" "}
        {getPresentationParamsForOrigin().appDomain}
      </>
    ) : (
      <>
        <strong>Tabelle:</strong> {getPresentationParamsForOrigin().appDomain}
      </>
    );

  return (
    <div
      style={{
        backgroundColor: "black",
        width: 1920,
        height: 1080,
        padding: 50,
      }}
    >
      <Group justify="space-between" align={"start"}>
        <div>
          <Text size="110px" c="white" fw={900}>
            {group?.name ?? "Tabelle"}
          </Text>
          <Text
            size="60px"
            c={getPresentationParamsForOrigin().colors.brand[7]}
            mt={30}
          >
            {textApp}
          </Text>
        </div>
        <div>
          <Image
            src={getPresentationParamsForOrigin().logo.light}
            height={130}
            maw={600}
            fit="contain"
            alt={getPresentationParamsForOrigin().competitionName}
          />
        </div>
      </Group>

      <Table
        style={{
          marginTop: -30,
          width: "100%",
          fontSize: 64,
          borderCollapse: "collapse",
        }}
      >
        <Table.Thead>
          <Table.Tr
            style={{
              borderBottom: "10px solid white",
            }}
          >
            <Table.Th colSpan={3} style={{ ...tdStyle }}></Table.Th>
            <Table.Th
              style={{ ...tdStyle, textAlign: "center", fontWeight: 700 }}
            >
              Sp
            </Table.Th>
            <Table.Th
              style={{ ...tdStyle, textAlign: "center", fontWeight: 700 }}
            >
              TD
            </Table.Th>
            <Table.Th
              style={{ ...tdStyle, textAlign: "center", fontWeight: 700 }}
            >
              P
            </Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {teams.map((t) => (
            <Table.Tr
              key={t.teamId}
              style={{ borderBottom: "5px solid #444444" }}
            >
              <Table.Td style={{ ...tdStyle, textAlign: "right", width: 100 }}>
                {t.position}.
              </Table.Td>
              <Table.Td style={{ width: 100 }}>
                <Box w={80}>
                  <TeamLogo height={80} teamId={t.teamId} />
                </Box>
              </Table.Td>
              <Table.Td style={{ ...tdStyle }}>
                <TeamName teamId={t.teamId} />
              </Table.Td>
              <Table.Td style={{ ...tdStyle, textAlign: "center" }}>
                {t.games}
              </Table.Td>
              <Table.Td
                style={{
                  ...tdStyle,
                  textAlign: "center",
                  color:
                    t.goalDifference > 0
                      ? "#4ade80"
                      : t.goalDifference < 0
                        ? "#f87171"
                        : "white",
                }}
              >
                {t.goalDifference > 0
                  ? `+${t.goalDifference}`
                  : t.goalDifference}
              </Table.Td>
              <Table.Td style={{ ...tdStyle, textAlign: "center" }}>
                {t.points}
              </Table.Td>
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
    </div>
  );
};
